// import external dependencies
import 'jquery';
import 'select2/dist/js/select2.min';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'daterangepicker/daterangepicker';
import 'custom-event-polyfill';
import numeral from 'numeral';

// Import everything from autoload
import './autoload/_application.js'; import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import applicationPage from './routes/application';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Application page
  applicationPage,
});

window.numeral = numeral;
numeral.register('locale', 'nl-nl', {
  delimiters: {
    thousands: '.',
    decimal  : ',',
  },
  abbreviations: {
    thousand : 'k',
    million  : 'mln',
    billion  : 'mrd',
    trillion : 'bln',
  },
  ordinal : function (number) {
    var remainder = number % 100;
    return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
  },
  currency: {
    symbol: '€ ',
  },
});

// switch between locales
numeral.locale('nl-nl');

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// resources/assets/scripts/main.js